import { useCallback, useEffect, useState } from "react";
import {
  COMPLETED,
  OFFLINE_COMPLETED,
  OFFLINE_PENDING,
  ON_HOLD,
  ONLINE_COMPLETED,
  ONLINE_PENDING,
  PENDING,
  PENDING_APPROVAL,
  REJECTED,
  SAVE_DRAFT,
  stateGstCodes,
  TRAVEL_PENDING,
  WAIT_LIST,
} from "../constants";
import { endPoints } from "../constants/urlConstants";
import {
  FormResponse,
  Program,
  ProgramDetails,
  ProgramQuestionMap,
  Question,
} from "../pages/Registration";
// import { getCall } from "../services/apiService";
import { S3Client, ListObjectsCommand } from "@aws-sdk/client-s3";
import { getCall, postCall } from "../services/apiService";
import dayjs from "dayjs";
import axios from "axios";
import { RegistrationStatus } from "../types/registration";
import { calCulatePercentage } from "./commonFunctions";
const s3 = new S3Client({
  region: process.env.REACT_APP_AWS_REGION, // 'ap-south-1',
  credentials: {
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID || "", // 'AKIATOWWTX6I3DL2PYXJ',      // ⚠️ Avoid hardcoding in real apps
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY || "", //'xBO1LykVgxozKVqXXxfZX9i661C/1PTU00lGCJ+q',  // ⚠️ Use Cognito or env variables
  },
});
export interface ProgramRegistration {
  id: string;
  program: {
    id: number;
    name: string;
    requiresApproval?: boolean;
    requiresPayment?: boolean;
    involvesTravel?: boolean; // can be removed
    isTravelInvolved?: boolean;
    noOfSession?: number;
    limitedSeats?: boolean;
    isGroupedProgram?: boolean; // For grouped programss
  };
  userId: string | null;
  fullName: string;
  programRegistrationSeqNumber?: string | null;
  waitingListSeqNumber?: string | null;
  mobileNumber: string;
  emailAddress: string;
  registrationStatus: string;
  basicDetailsStatus: string;
  invoiceDetails?: any[];
  paymentDetails?: any[];
  travelInfo?: any[];
  travelPlans?: any[];
  registrationDate: string | null;
  allocatedProgram?: Program | null; // For grouped programs
  programSession?: Program | null; // For programs with multiple sessions
}

export interface userRegistration {
  id: string;
  program: {
    id: number;
    name: string;
    requiresApproval?: boolean;
    requiresPayment?: boolean;
    involvesTravel?: boolean; // can be removed
    isTravelInvolved?: boolean;
    noOfSession?: number;
    limitedSeats?: boolean;
    isGroupedProgram?: boolean; // For grouped programss
  };
  fullName: string;
  userId?: string | null;
  registrationSeqNumber?: string | null;
  programRegistrationSeqNumber?: string | null;
  waitingListSeqNumber?: string | null;
  mobileNumber: string;
  emailAddress: string;
  registrationStatus: string;
  basicDetailsStatus: string;
  registrationDate: string | null;
  travelInfo: any[];
  travelPlans: any[];
  invoiceDetails: any[];
  paymentDetails: any[];
  allocatedProgram?: Program | null; // For grouped programs
  programSession?: Program | null; // For programs with multiple sessions
}

interface RegistrationQuestion {
  questionId: number;
  questionLabel: string;
  sectionId: number;
  sectionName: string;
  answer: string;
}

export interface GroupedQuestion {
  // questionId: number;
  // questionLabel: string;
  // sectionName: string;
  // answer: string;
  [key: number]: string; // Dynamic keys for questionId and answer
}
export const createBindingKeyMap = (userData, questions) => {
  const bindingMap = {};

  questions.forEach((pqm) => {
    const bindingKey = pqm.question.bindingKey;
    if (bindingKey && userData[bindingKey] !== undefined) {
      bindingMap[pqm.question.id] = {
        value: userData[bindingKey],
        bindingKey,
        hasExistingData:
          userData[bindingKey] !== null && userData[bindingKey] !== "",
      };
    }
  });

  return bindingMap;
};

export const fetchRegistrationStatus = async (
  endPoint: string,
  setData: (data: any) => void,
  programId?: any,
) => {
  getCall(endPoint, undefined, false)
    .then((response) => {
      if (response.status === 200) {
        if (programId === undefined || programId === null) {
          setData(response.data.data.data);
        } else {
          const details = getProgramDetails(programId, response.data.data.data);
          setData(details);
        }
      } else {
        setData({});
      }
    })
    .catch((error) => {
      console.error("Error fetching registration status:", error);
      setData({});
    });
  return null; // Default return if no data is fetched
};

export const getProgramRegistration = (
  programId: number,
  registrations: ProgramRegistration[],
): ProgramRegistration | undefined => {
  // const registration = registrations.find(reg => reg.program.id === programId);
  return registrations.find(
    (reg) => reg.program.id == programId && reg.userId != null,
  );
};

// Example usage with type checking
const getProgramDetails = (
  programId: number,
  registrations: ProgramRegistration[],
): userRegistration | null => {
  const registration = getProgramRegistration(programId, registrations);

  if (!registration) {
    return null;
  }

  return {
    id: registration.id,
    program: registration.program,
    fullName: registration.fullName,
    programRegistrationSeqNumber:
      registration.programRegistrationSeqNumber || null,
    waitingListSeqNumber: registration.waitingListSeqNumber || null,
    mobileNumber: registration.mobileNumber,
    emailAddress: registration.emailAddress,
    registrationStatus: registration.registrationStatus,
    basicDetailsStatus: registration.basicDetailsStatus,
    registrationDate: registration.registrationDate,
    travelInfo: registration.travelInfo || [],
    travelPlans: registration.travelPlans || [],
    invoiceDetails: registration.invoiceDetails || [],
    paymentDetails: registration.paymentDetails || [],
    allocatedProgram: registration.allocatedProgram || null, // For grouped programs
    programSession: registration.programSession || null, // For programs with multiple sessions
  };
};

export const getFormStatus = (
  userStatus: userRegistration | null,
  programDetails: ProgramDetails | null,
  showAdditionalInfo: boolean,
  editRegistration: boolean,
): boolean => {
  if (
    userStatus?.registrationStatus === "pending" ||
    userStatus?.registrationStatus == null ||
    userStatus?.registrationStatus == undefined ||
    userStatus?.registrationStatus === "draft" ||
    userStatus?.registrationStatus === SAVE_DRAFT
  ) {
    return true;
  } else if (
    (userStatus?.registrationStatus === "completed" &&
      programDetails?.type.involvesTravel &&
      userStatus?.travelInfo.length === 0 &&
      showAdditionalInfo) ||
    userStatus?.registrationStatus === "pending"
  ) {
    return true;
  } else if (
    (userStatus?.registrationStatus === PENDING_APPROVAL ||
      // userStatus?.registrationStatus === WAIT_LIST ||
      userStatus?.registrationStatus === ON_HOLD ||
      (userStatus?.approvals && userStatus?.approvals.length > 0 && userStatus?.approvals[0]?.approvalStatus == ON_HOLD ) ||
      userStatus?.registrationStatus === REJECTED) &&
    editRegistration
  ) {
    console.log("editRegistration", editRegistration);
    return true;
  } 
  return false;
};

export const sectionConstants = {
  invoiceDetails: "Invoice", //2
  travelInfo: "Travel Plan & Goodies", //3
};

export const fetchProgramsData = async (userId: string) => {
  try {
    const [programsResponse, registrationsResponse] = await Promise.all([
      getCall(
        endPoints.getProgramEndPoint({ status: "published" }),
        undefined,
        false,
      ), // list og published programs
      getCall(`user/${userId}/registrations?limit=100`, undefined, false), //list of registrations for the user
    ]);

    return {
      programs: programsResponse.data.data.data,
      registrations: registrationsResponse.data.data.data,
    };
  } catch (error) {
    throw new Error("Failed to fetch program data");
  }
};

export const getStatusOfProgram = (
  programs: ProgramDetails[],
  registrations: userRegistration[],
) => {
  const programStatusMap: ProgramDetails[] = [];
  // console.log("The programs are ", programs);

  programs.map((program: ProgramDetails) => {
    const registration = registrations.find(
      (reg) => reg?.program?.id === program?.id && reg?.userId != null,
    );
    console.log("registration status of the program", registration?.id);
    console.log("registration status of the program abc", registration);
    // if (registration) {

    //   programStatusMap[program.id] =
    // } else {
    //   programStatusMap[program.id] = {
    //     ...program,
    //     statusMessage: undefined
    //   };
    // }
    const travelInfo = registration?.travelInfo || [];
    programStatusMap.push({
      ...program,
      // ...registration,
      registrationId: registration?.id || null,
      blessesProgram: program.isGroupedProgram
        ? registration?.allocatedProgram
        : program?.noOfSession
          ? registration?.programSession
          : null,
      statusMessage: registration
        ? getStatusMessage(program, registration)
        : undefined,

      travelInfo: travelInfo,
    });
  });
  console.log("programStatusMap", programStatusMap);
  return programStatusMap;
};

const getStatusMessage = (
  program: ProgramDetails,
  registration: userRegistration,
): object => {
  var allocatedProgram = "";
  console.log("The programs are ", program),
  console.log("getStatusMessage program", registration?.paymentDetails[0]);
  if (program.isGroupedProgram) {
    allocatedProgram = registration?.allocatedProgram?.name || "";
  } else if (program?.noOfSession > 0) {
    allocatedProgram = registration?.programSession?.name || "";
  } else {
    allocatedProgram = program.name;
  }
  if (registration.registrationStatus === SAVE_DRAFT) {
    // return "Registered to program and awaiting for approval";
    // return {message : [`You’ve been registered for ${program.name}.`, "We’ll be in touch with the next steps and all the details soon."], state : PENDING_APPROVAL };
    return {
      message: [""],
      state: SAVE_DRAFT,
    };
  } else if (registration.registrationStatus === PENDING_APPROVAL) {
    // return "Registered to program and awaiting for approval";
    // return {message : [`You’ve been registered for ${program.name}.`, "We’ll be in touch with the next steps and all the details soon."], state : PENDING_APPROVAL };
    return {
      message: [
        "Thanks for completing your registration.",
        "Your request has now been placed with Mahatria. You can edit your registration details and program choice until you are blessed with a seat.",
      ],
      state: PENDING_APPROVAL,
    };
  }
  else if(registration?.approvals && registration?.approvals.length > 0 && registration?.approvals[0]?.approvalStatus == ON_HOLD){
    return {
      message: [
        "Thanks for completing your registration.",
        "Your request has now been placed with Mahatria",
      ],
      state: ON_HOLD,
    };
  }
  else if (registration.registrationStatus === REJECTED) {
    // Treating REJECTED same as ON_HOLD for the seeker
    return {
      message: [
        "Thanks for completing your registration.",
        "Your request has now been placed with Mahatria",
      ],
      state: REJECTED,
    };
  } else if (
    program.limitedSeats &&
    registration.registrationStatus === WAIT_LIST
  ) {
    // return "Registered to program and seat is waiting list";
    return {
      message: [
        `You’ve been registered for ${program.name}.`,
        "We’ll be in touch with the next steps and all the details soon.",
      ],
      state: PENDING_APPROVAL,
    };
  } else if (
    registration?.program.requiresPayment &&
    registration?.paymentDetails.length === 0
  ) {
    
    // return "Registered to program and payment pending";
    return {
      message: [
        // `Your participation in ${allocatedProgram} is now approved by Mahatria.`,
        // "To move ahead, please click the Make Payment button below. You can also download your Pro-forma Invoice for reference.",
        `${allocatedProgram} - ${formatDateWithDay(program?.startsAt)} to ${formatDateWithDay(program?.endsAt)}`,
        'Please complete your payment',
        `Click here to download 'Pro-forma Invoice'`,
      ],
      state: PENDING,
    };
  } else if (
    registration?.program.requiresPayment &&
    registration?.paymentDetails.length > 0
  ) {
    if (registration?.paymentDetails[0]?.paymentStatus == ONLINE_PENDING) {
      // return "Registered to program and online payment pending";
      return {
        message: [
          `Your participation in ${allocatedProgram} is now approved by Mahatria.`,
          "To move ahead, please click the Make Payment button below. Click here to download 'Pro-forma Invoice",
        ],
        state: PENDING,
      };
    } else if (
      registration?.paymentDetails[0]?.paymentStatus == OFFLINE_PENDING &&
      registration.registrationStatus == COMPLETED
    ) {
      // return "Registered to program and offline payment pending";
      return {
        message: [
          `Your payment for ${allocatedProgram} is successfully recorded.`,
          "We will update your status as soon as payment is completed.",
        ],
        state: COMPLETED,
      };
    } else if (
      registration?.paymentDetails[0]?.paymentStatus == OFFLINE_PENDING
    ) {
      // return "Registered to program and offline payment pending";
      return {
        message: [
          // `Your payment for ${allocatedProgram} is successfully recorded.`,
          // "To proceed, please share your travel plan below. We will update your status as soon as payment is completed.",
          `We acknowledge your payment towards ${allocatedProgram} - ${formatDateWithDay(program?.startsAt)} to ${formatDateWithDay(program?.endsAt)}`,
          "Note: Cheques are subject to realization",
          "Please update your travel plan"
        ],
        state: TRAVEL_PENDING,
      };
    } else if (
      registration?.paymentDetails[0]?.paymentStatus?.includes("completed") &&
      registration?.registrationStatus == PENDING
    ) {
      // return "Registered to program and payment completed";
      return {
        message: [
          // `Your payment for ${allocatedProgram} is successfully recorded.`,
          // "To proceed, please share your travel plan below. You may also download your invoice.",
          `Payment towards ${formatDateWithDay(program?.startsAt)} to ${formatDateWithDay(program?.endsAt)} is successful.`,
          `Click here to download 'Tax invoice'`,  
          `Please update your travel plan`
        ],
        state: TRAVEL_PENDING,
      };
    }
  } else if (
    registration?.program.isTravelInvolved &&
    registration?.travelInfo.length === 0
  ) {
    // return "Registered to program and travel details pending";
    return {
      message: [
        `Your payment for ${allocatedProgram} is successfully recorded.`,
        "To proceed, please share your travel plan below. You may also download your invoice.",
      ],
      state: TRAVEL_PENDING,
    };
    // return {statusMessage : "Registered to program and travel details pending", text : "Go to travel"};
  }
  // return "Registered to program completed";
  return {
    message: [
      "Your seat is confirmed, your invoice has been linked, and your travel plan is all set. Click the Summary button to view your complete registration details anytime. You may also download your invoice.",
    ],
    state: COMPLETED,
  };
};
function formatDateWithDay(dateString: string) {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, "0");
  const month = date.toLocaleString("en-GB", { month: "short" });
  const year = date.getFullYear();
  const weekday = date.toLocaleDateString("en-GB", { weekday: "long" });
  return `${day}-${month}-${year} (${weekday})`;
}

const testS3Connection = async () => {
  try {
    const result = await s3.send(
      new ListObjectsCommand({
        Bucket: "infinitheism-serverless",
        MaxKeys: 1,
      }),
    );
    console.log(" AWS is configured correctly", result);
    return true;
  } catch (err) {
    console.error(" AWS configuration error:", err);
    return false;
  }
};

export const handleAWSFileUpload = async (
  file: File,
): Promise<string | null> => {
  try {
    const payload = {
      fileName: file.name,
      contentType: file.type,
    };
    const fileUrls = await postCall(endPoints.fileUpload, payload, false);
    if (fileUrls?.data?.data?.accessUrl && fileUrls?.data?.data?.putUrl) {
      const blob = await convertFileToBlob(file);
      await axios.put(fileUrls.data.data.putUrl, blob);
      return fileUrls.data.data.accessUrl;
    } else {
      alert("File upload failed. Please try again");
      return null;
    }
  } catch (error) {
    alert("File upload failed. Please try again.");
    return null;
  }
};

const convertFileToBlob = async (file: File) => {
  const arrayBuffer = await file.arrayBuffer();
  const blob = new Blob([arrayBuffer], { type: file.type });
  return blob;
};

export const formatDateToWeekDate = (date: string): string => {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const [year, month, day] = date.split("-").map(Number);
  const monthName = months[month - 1];

  return `${monthName} ${day}, ${year}`;
};

export const validateCurrentSection = async (
  currentSectionIndex: number,
  groupedQuestions: {
    [key: number]: {
      section: any;
      hasData: ProgramQuestionMap[];
      needData: ProgramQuestionMap[];
      questions: ProgramQuestionMap[];
      subSection?: ProgramQuestionMap[];
    };
  } | null,
  setErrors: any,
  formData: FormResponse,
  allocatedProgram: Program | null,
): boolean => {
  // const groupedQuestions = getGroupedQuestions();
  console.log("Validating current section", formData);
  try {
    if (!groupedQuestions) return false;
    const sections = Object.values(groupedQuestions);
    const currentSection = sections[currentSectionIndex - 1];

    if (!currentSection) return true;
    const newErrors: { [key: string]: string } = {};
    let isValid = true;
    await Promise.all(
      currentSection.hasData.map(async (pqm) => {
        // if(formData[currentSectionIndex] && formData[currentSectionIndex][pqm.question.id]) {
        const error = await validateField(
          pqm.question,
          formData[currentSectionIndex][pqm.question.id],
          formData[currentSectionIndex],
          currentSectionIndex,
          allocatedProgram
        );
        if (error) {
          newErrors[pqm.question.id] = error;
          isValid = false;
        }
        // }
      }),
    );
    await Promise.all(
      currentSection.needData.map(async (pqm) => {
        // if(formData[currentSectionIndex] && formData[currentSectionIndex][pqm.question.id]) {

        const error = await validateField(
          pqm.question,
          formData[currentSectionIndex][pqm.question.id],
          formData[currentSectionIndex],
          currentSectionIndex,
          allocatedProgram
        );
        if (error) {
          newErrors[pqm.question.id] = error;
          isValid = false;
        }
        // }
      }),
    );

    await Promise.all(
      (currentSection?.subSection || []).map(async (pqm) => {
        const error = await validateField(
          pqm.question,
          formData[currentSectionIndex][pqm.question.id],
          formData[currentSectionIndex],
          currentSectionIndex,
          allocatedProgram
        );
        if (error) {
          newErrors[pqm.question.id] = error;
          isValid = false;
        }
      }),
    );
    // if (currentSectionIndex === 2) {
    //   const pincode = formData[currentSectionIndex][1054];
    //   const gstNumber = formData[currentSectionIndex][1055];
    //   const tdsAmount = formData[currentSectionIndex][1056];
    //   // New cheque number validation
    //   const chequeNumber = formData[currentSectionIndex][504];
    //   // Find pqm for chequeNumber (id 504)
    //   let chequePqm = null;
    //   if (currentSection && currentSection.questions) {
    //     chequePqm = currentSection.questions.find(
    //       (pqm) => pqm.question.id === 504,
    //     );
    //   }
    //   if (chequeNumber && chequePqm) {
    //     const allowedDigits = chequePqm.question.config?.allowedDigits;
    //     const chequeStr = chequeNumber.toString();
    //     if (allowedDigits) {
    //       // allowedDigits is a number, chequeStr should be exactly that many digits
    //       const digitRegex = new RegExp(`^\\d{${allowedDigits}}$`);
    //       if (!digitRegex.test(chequeStr)) {
    //         newErrors[504] = `Must be exactly ${allowedDigits} digits`;
    //         isValid = false;
    //       }
    //     }
    //   }
    //   if (gstNumber && pincode) {
    //     const isValidGST = await validateGSTNumber(pincode, gstNumber);
    //     if (!isValidGST) {
    //       newErrors[1055] =
    //         "GST number does not match the state for the given pincode";
    //       isValid = false;
    //     }
    //   }
    //   const allowedTds = stringToNumber(allocatedProgram?.tdsPercent);
    //   const tdsPercentage =
    //     (Number(tdsAmount) / Number(allocatedProgram?.basePrice)) * 100;
    //   if (allowedTds < tdsPercentage) {
    //     newErrors[1056] = `TDS percent cannot be more than ${allocatedProgram?.tdsPercent}% for this program`;
    //     isValid = false;
    //   }
    // }
    setErrors(newErrors);
    return isValid;
  } catch (error) {
    console.error("Error validating current section:", error);
    // setErrors({ general: "An error occurred while validating the form." });
    return false;
  }
};

export function stringToNumber(value: string): number {
  return parseFloat(value) || 0;
}
export const validateField = async (
  question: Question,
  value: any,
  formData: FormResponse,
  currentSectionIndex: number,
  allocatedProgram: any
): string | null => {
  const { config } = question;
  if (
    config.isRequired &&
    (!value || value.toString().trim() === "") &&
    isDepndencySatisfied(question, value, formData)
  ) {
    return `required`;
  }

  if (question.type === "date" && value) {
    const dateError = validateDateInput(value, config);
    if (dateError) {
      return dateError;
    }
    // const currentDate = new Date();
    // const inputDate = new Date(value);
    // const age = currentDate.getFullYear() - inputDate.getFullYear();
    // if (validateDateWithDynamicRange(value, config?.pastDateValidation, config?.futureDateValidation)) {
    // return "invalid date";
    // }
  }
  if (
    value &&
    config.minCharacter &&
    value.toString().length < config.minCharacter
  ) {
    return `min limit: ${config.minCharacter}`;
  }

  if (
    value &&
    config.maxCharacters &&
    value.toString().length > config.maxCharacters
  ) {
    return `max limit: ${config.maxCharacters}`;
  }
  console.log("ssssvalue", value, config.maxValue, question.type === "number");

  if (
    value &&
    (config.minValue || config.minValue === 0) &&
    question.type === "number" &&
    value < config.minValue
  ) {
    return `min limit: ${config.minValue}`;
  }

  if (
    value &&
    config.maxValue &&
    question.type === "number" &&
    value > config.maxValue
  ) {
    return `max limit: ${config.maxValue}`;
  }

  if (question.type === "email" && value) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) {
      return "Please enter a valid email address";
    }
  }

  if (config.validationPattern && value) {
    const regex = new RegExp(config.validationPattern);
    if (!regex.test(value)) {
      return `invalid format`;
    }
  }


    if (currentSectionIndex === 2 && formData) {
        const pincode = formData[1054];
        const gstNumber = formData[1055];
        const tdsAmount = formData[1056];
        // New cheque number validation
        const chequeNumber = formData[504];

        if (chequeNumber && question.bindingKey == "chequeNo") {
          const allowedDigits = question.config?.allowedDigits;
          const chequeStr = chequeNumber.toString();
          if (allowedDigits) {
            // allowedDigits is a number, chequeStr should be exactly that many digits
            const digitRegex = new RegExp(`^\\d{${allowedDigits}}$`);
            if (!digitRegex.test(chequeStr)) {
              return `Must be exactly ${allowedDigits} digits`;
            }
          }
        }
        if (gstNumber && pincode) {
          const isValidGST = await validateGSTNumber(pincode, gstNumber);
          if (!isValidGST) {
            return "GST number does not match the state for the given pincode";
          }
        }
        const allowedTds = stringToNumber(allocatedProgram?.tdsPercent);
        const tdsPercentage = calCulatePercentage(Number(tdsAmount), Number(allocatedProgram?.basePrice))
        if (allowedTds < tdsPercentage) {
          return `TDS percent cannot be more than ${allocatedProgram?.tdsPercent}% for this program`;
        }
      }
      return null;
};

export function validateDateInput(
  value: string | Date,
  config: any,
): string | null {
  if (!value) return "Date is required";
  const inputDate = dayjs(value);

  // Static validation: between startDate and endDate
  if (config.dateValidationType === "static") {
    if (
      config.startDate &&
      inputDate.isBefore(dayjs(config.startDate), "day")
    ) {
      return `Date should not be before ${dayjs(config.startDate).format("DD/MM/YYYY")}`;
    }
    if (config.endDate && inputDate.isAfter(dayjs(config.endDate), "day")) {
      return `Date should not be after ${dayjs(config.endDate).format("DD/MM/YYYY")}`;
    }
    return null;
  }
  console.log("config should", config);

  // Dynamic validation: future and past
  const today = dayjs().startOf("day");

  // Past validation (e.g., age should be at least minValue years and at most maxValue years)
  if (config.pastValidation?.enabled) {
    const { unit, minValue, maxValue } = config.pastValidation;
    const diff = today.diff(inputDate, unit);
    if (maxValue != null && diff > maxValue) {
      return `Date should not be more than ${maxValue} ${unit} in the past`;
    }
    if (minValue != null && diff < minValue) {
      return `Date should be at least ${minValue} ${unit} in the past`;
    }
  } else {
    if (inputDate.isBefore(today)) {
      return `Date should not be in the past`;
    }
  }

  // Future validation (e.g., date should not be too far in the future)
  if (config.futureValidation?.enabled) {
    const { unit, minValue, maxValue } = config.futureValidation;
    const diff = inputDate.diff(today, unit);

    if (minValue != null && diff < minValue) {
      return `Date should not exceed ${minValue} ${unit} in the future`;
      // return `Date should be at least ${minValue} ${unit} in the future`;
    }
    if (maxValue != null && diff > maxValue) {
      return `Date should not be more than ${maxValue} ${unit} in the future`;
    }
  } else {
    // If future validation is disabled, date should not be in the future
    if (inputDate.isAfter(today)) {
      return `Date should not be in the future`;
    }
  }

  return null; // Valid
}

const isDepndencySatisfied = (
  question: Question,
  value: any,
  formData: FormResponse,
): boolean => {
  if (
    question?.config?.dependsOn == null ||
    question.config.dependsOn?.length == 0
  )
    return true;

  const dependency = question.config.dependsOn?.some((dep) => {
    if (dep.value == "notNull") {
      return (
        formData[dep.questionId] != null && formData[dep.questionId] !== ""
      );
    }
    return formData[dep.questionId] == dep.value;
  });
  return dependency || false;
};
interface RegistrationState {
  programDetails: ProgramDetails | null;
  groupedAnswersData: { [key: number]: GroupedQuestion } | null;
  userStatus: userRegistration | null;
  groupedQuestions: any;
  loading: boolean;
  error: Error | null;
}

const initialState: RegistrationState = {
  programDetails: null,
  groupedAnswersData: null,
  userStatus: null,
  groupedQuestions: null,
  loading: true,
  error: null,
};

export const useRegistrationData = (programId: string, seekerId: string) => {
  const [state, setState] = useState<RegistrationState>(initialState);

  const fetchData = useCallback(async () => {
    setState((prev) => ({ ...prev, loading: true, error: null }));

    try {
      // First get registration data to get registrationId
      const registrationResponse = await getCall(
        `user/${seekerId}/registrations?programId=${programId}`,
        undefined,
        false, // user registration status
      );

      const registrationData = registrationResponse?.data?.data?.data;
      const registrationId = registrationData?.[0]?.id;

      // Then fetch all data in parallel including registration questions
      const [programResponse, prefillResponse, registrationAnswersResponse] =
        await Promise.all([
          getCall(`program/${programId}`, undefined, false), // api to render form
          getCall(`user/${seekerId}/prefill`, undefined, false), // prefill data for the user
          registrationId
            ? getCall(
                `registration/${registrationId}/questions`,
                undefined,
                false,
              )
            : Promise.resolve(null), // user entered answers
        ]);
      const prefillData = prefillResponse?.data.data;
      const programData = programResponse?.data?.data;
      // const userData = userResponse?.data?.data;
      const answersData = registrationAnswersResponse?.data.data;
      const groupedAnswersData = registrationId
        ? groupRegistrationQuestions(answersData)
        : {};
      const { grouped, prefilledanswersData } = await getGroupedQuestions(
        programData,
        groupedAnswersData,
        registrationId,
        prefillData,
      );
      const groupedPrefilledAnswersData = mergedPrefilledData(
        prefilledanswersData,
        groupedAnswersData,
      );
      console.log("groupedPrefilledAnswersData", groupedPrefilledAnswersData);
      const userStatus = getProgramDetails(Number(programId), registrationData);

      setState((prev) => ({
        ...prev,
        programDetails: programData,
        groupedAnswersData: groupedPrefilledAnswersData,
        userStatus: userStatus,
        // Pass questionsData instead of userData to getGroupedQuestions
        groupedQuestions: programData ? grouped : null,
        loading: false,
      }));
    } catch (error) {
      setState((prev) => ({
        ...prev,
        error: error as Error,
        loading: false,
      }));
    }
  }, [programId, seekerId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return {
    ...state,
    refetch: fetchData,
  };
};

export const mergedPrefilledData = (
  prefilledAnswersData: RegistrationQuestion[] | null,
  groupedAnswersData: { [key: number]: GroupedQuestion } | null,
): { [key: number]: GroupedQuestion } => {
  if (!prefilledAnswersData || !groupedAnswersData)
    return groupedAnswersData || {};
  Object.entries(prefilledAnswersData).forEach(([key, value]) => {
    var sectionId = value.sectionId;
    console.log("sectionIdprefilledAnswersData", sectionId);
    if (sectionId == 4) {
      sectionId = 1;
    }
    if (!groupedAnswersData[sectionId]) {
      groupedAnswersData[sectionId] = {};
      groupedAnswersData[sectionId][value.questionId] = value.answer;
    } else {
      if (!groupedAnswersData[sectionId][value.questionId]) {
        groupedAnswersData[sectionId][value.questionId] = value.answer;
      }
    }
  });
  console.log(
    "sectionIdprefilledAnswersData groupedAnswersData",
    groupedAnswersData,
  );
  return groupedAnswersData;
};

export const groupRegistrationQuestions = (
  questions: RegistrationQuestion[],
): { [key: number]: GroupedQuestion } => {
  const grupedAnswers = questions.reduce(
    (grouped, question) => {
      const { sectionId, questionId, answer } = question;
      var secId = sectionId;
      if (secId == 4) {
        secId = 1; // Adjust sectionId if it is 4
      }
      if (!grouped[secId]) {
        grouped[secId] = {};
      }

      // Add the question answer with questionId as key
      grouped[secId][questionId] = answer;

      return grouped;
    },
    {} as { [key: number]: GroupedQuestion },
  );

  return grupedAnswers;
};

const getGroupedQuestions = async (
  programDetails,
  userDetails,
  registrationId,
  prefillData,
) => {
  if (!programDetails) return {};
  let prefilledanswersData = [];
  const apicallPQMs = [];
  const grouped = programDetails.programQuestionMaps.reduce(
    (acc, pqm) => {
      var sectionId = pqm.question.formSection.id;
      if (sectionId == 4) {
        sectionId = 1;
      }
      if (!acc[sectionId]) {
        acc[sectionId] = {
          section: pqm.question.formSection,
          hasData: [],
          needData: [],
          questions: [],
          subSection: [],
        };
      }
      if (pqm.question.type === "apicall") {
        console.log(
          "API options fetched successfully: console",
          pqm.question.questionOptionMaps,
        );
        // Only fetch if not already loaded
        if (
          !pqm.question.questionOptionMaps ||
          pqm.question.questionOptionMaps.length === 0
        ) {
          apicallPQMs.push(pqm);
        }
      }

      const hasUserData =
        registrationId && userDetails[sectionId] != null
          ? Object.entries(userDetails[sectionId]).filter(([key, value]) => {
              return key == pqm.question.id;
            })
          : [];
      const hasPrefilledData =
        prefillData && prefillData[pqm.question.bindingKey] != null
          ? {
              questionId: pqm.question.id,
              questionLabel: pqm.question.label,
              sectionId:
                pqm.question.formSection.id == 4
                  ? 1
                  : pqm.question.formSection.id,
              sectionName: pqm.question.formSection.name,
              answer: prefillData[pqm.question.bindingKey],
            }
          : null;

      if (hasPrefilledData) {
        prefilledanswersData.push(hasPrefilledData);
      }
      if (pqm.question.formSection.id == 4) {
        acc[sectionId].subSection.push(pqm);
      } else if (hasUserData.length > 0 || hasPrefilledData) {
        acc[sectionId].hasData.push(pqm);
      } else {
        acc[sectionId].needData.push(pqm);
      }
      if (pqm.question.formSection.id != 4) {
        acc[sectionId].questions.push(pqm);
      }
      return acc;
    },
    {} as {
      [key: number]: {
        section: any;
        hasData: ProgramQuestionMap[];
        needData: ProgramQuestionMap[];
        questions: ProgramQuestionMap[];
        subSection?: ProgramQuestionMap[];
      };
    },
  );
  for (const pqm of apicallPQMs) {
    await fetchApiOptions(pqm);
  }
  Object.values(grouped).forEach((group) => {
    group.hasData.sort((a, b) => a.displayOrder - b.displayOrder);
    group.needData.sort((a, b) => a.displayOrder - b.displayOrder);
    group.questions.sort((a, b) => a.displayOrder - b.displayOrder);
    group.subSection.sort((a, b) => a.displayOrder - b.displayOrder);
  });
  // Pre-populate form data with existing user data
  const newFormData: FormResponse = {};
  Object.values(grouped).forEach((group) => {
    group.hasData.forEach((pqm) => {
      if (pqm.question.bindingKey && userDetails[pqm.question.bindingKey]) {
        newFormData[pqm.question.id] = userDetails[pqm.question.bindingKey];
      }
    });
  });
  return { grouped, prefilledanswersData };
};

const fetchApiOptions = async (pqm: ProgramQuestionMap) => {
  // try {
  // You may want to store the endpoint in pqm.question.config or elsewhere
  // For demo, let's assume pqm.question.config.apiEndpoint exists
  const apiEndpoint = pqm.question.config?.endPoint;
  if (!apiEndpoint) return Promise.resolve();
  await getCall(apiEndpoint, undefined, false)
    .then((response) => {
      if (response?.data?.statusCode === 200) {
        console.log(
          "API options fetched successfully:API options fetched successfully:",
          response.data.data.data,
        );
        // Map API response to questionOptionMaps format
        pqm.question.questionOptionMaps = response.data.data.data.map(
          (item: any, idx: number) => ({
            option: {
              id: item.id ?? 8319,
              name: item.name ?? item.fullName,
            },
          }),
        );
      }
    })
    .catch((error) => {
      console.error("Error fetching API options:", error);
    });
};

export const getCurrentSection = (
  setCurrentSectionIndex: (value: any) => void,
  userStatus: userRegistration | null,
  editRegistration: boolean,
  showAdditionalInfo: boolean,
  showSuccess: boolean,
) => {
  console.log("userStatus?.travelInfo", !editRegistration);
  if (
    userStatus?.registrationStatus == null ||
    userStatus?.registrationStatus === undefined ||
    userStatus?.registrationStatus === "draft" ||
    userStatus?.registrationStatus === SAVE_DRAFT ||
    (userStatus.registrationStatus === PENDING_APPROVAL && editRegistration) ||
    (userStatus?.registrationStatus === WAIT_LIST && editRegistration) ||
    (userStatus?.registrationStatus === ON_HOLD && editRegistration) ||
    (userStatus?.approvals && userStatus?.approvals.length > 0 && userStatus?.approvals[0]?.approvalStatus == ON_HOLD ) ||
     (userStatus?.registrationStatus === REJECTED && editRegistration)
  ) {
    console.log("userStatus?.travelInfo", 1);
    setCurrentSectionIndex(1);
  } else if (
    // userStatus?.invoiceDetails &&
    // userStatus?.invoiceDetails.length == 0 &&
    !editRegistration &&
    (userStatus?.invoiceDetails.length == 0 ||
      userStatus?.paymentDetails.length == 0 ||
      (userStatus?.registrationStatus == PENDING &&
        (userStatus.paymentDetails[0]?.paymentStatus === ONLINE_PENDING ||
          userStatus.paymentDetails[0]?.paymentStatus === "draft" ||
          userStatus?.paymentDetails.length == 0)))
  ) {
    console.log("userStatus?.travelInfo", 2);
    setCurrentSectionIndex(2);
  } else if (
    (userStatus?.registrationStatus == PENDING ||
      userStatus?.registrationStatus == COMPLETED) &&
    userStatus?.travelInfo &&
    userStatus?.travelInfo.length == 0 &&
    showAdditionalInfo &&
    !showSuccess
  ) {
    console.log("userStatus?.travelInfo", 3);
    setCurrentSectionIndex(3);
  }
  return;
};

export const getApprovalStatus = (
  userStatus: userRegistration | null,
  editRegistration: boolean,
) => {
  return (
    (userStatus?.registrationStatus === PENDING_APPROVAL &&
      !editRegistration) ||
    userStatus?.registrationStatus === WAIT_LIST ||
    userStatus?.registrationStatus === ON_HOLD ||
    (userStatus?.approvals && userStatus?.approvals.length > 0 && userStatus?.approvals[0]?.approvalStatus == ON_HOLD ) ||
    userStatus?.registrationStatus === REJECTED
  );
};

export const getCurrentWaitingHeader = (
  userStatus: userRegistration | null,
  editRegistration: boolean,
): { title: string; description: string } => {
  if (
    userStatus?.registrationStatus === PENDING_APPROVAL &&
    !editRegistration
  ) {
    return {
      title: "Awaiting Mahatria's Approval",
      description:
        "Thanks for completing your registration. Your request has now been placed with  Mahatria",
    };
  }
  if (userStatus?.registrationStatus === WAIT_LIST) {
    return { title: "Waiting List Confirmation", description: "waiting list" };
  }
  if (userStatus?.registrationStatus === ON_HOLD || (userStatus?.approvals && userStatus?.approvals.length > 0 && userStatus?.approvals[0]?.approvalStatus == ON_HOLD )) {
    return {
      title: "Registration is yet to be decided",
      description: "Embrace the Divine Experience yet to be decided",
    };
  }
  return {
    title: "Registration is on hold",
    description: "Embrace the Divine Experience on hold",
  };
};

export function mergeArrayOfObjects(
  arr: Array<Record<string, any>>,
): Record<string, any> {
  return arr.reduce((acc, obj) => ({ ...acc, ...obj }), {});
}

export function formatDateRangeToReadable(start: string, end: string): string {
  if (!start || !end) return "";

  const startDate = new Date(start);
  const endDate = new Date(end);

  const startDay = startDate.getDate();
  const endDay = endDate.getDate();
  const startMonth = startDate.toLocaleString("en-US", { month: "long" });
  const endMonth = endDate.toLocaleString("en-US", { month: "long" });
  const startYear = startDate.getFullYear();
  const endYear = endDate.getFullYear();

  // If both dates are the same
  if (startDay === endDay && startMonth === endMonth && startYear === endYear) {
    return `${startDay} ${startMonth}, ${startYear}`;
  }

  // Same month and year
  if (startDate.getMonth() === endDate.getMonth() && startYear === endYear) {
    return `${startDay} - ${endDay} ${startMonth}, ${startYear}`;
  } else {
    // Different month or year
    return `${startDay} ${startMonth} - ${endDay} ${endMonth}, ${endYear}`;
  }
}

export const getInputValues = (
  programDetails: Program | null,
  formData: any,
  toPrefill?: boolean,
) => {
  console.log("programDetails", programDetails);

  const adminGST = programDetails?.gstNumber || "";

  const combinedGst =
    (stringToNumber(programDetails?.cgst) +
      stringToNumber(programDetails?.sgst)) |
    0;
  const igst = stringToNumber(programDetails?.igst) | 0;

  var gstPercentage = combinedGst;
  var tds = 0;
  if (formData && formData[1055] != undefined && formData[1055] != null) {
    const GSTNumber = formData[1055];
    if (GSTNumber.slice(0, 2) == adminGST.slice(0, 2)) {
      gstPercentage = igst;
    }
  }
  if (formData[1056] != undefined && formData[1056] != null) {
    tds = formData[1056] || 0;
  }
  let gstLabel = "GST @" + gstPercentage + "%";
  const taxFee =
    stringToNumber(programDetails?.basePrice) * (gstPercentage / 100);
  let totalAmount = 0;
  let tdsPercentage = tds;
  let taxTdsPercentage = taxFee * (tds / 100);
  if (programDetails?.tdsApplicability == "base_only") {
    totalAmount = (
      stringToNumber(programDetails?.basePrice) -
      tdsPercentage +
      taxFee
    ).toFixed(2);
  } else {
    totalAmount = (
      stringToNumber(programDetails?.basePrice) -
      taxTdsPercentage +
      taxFee
    ).toFixed(2);
  }

  console.log(
    "total Amount",
    totalAmount,
    stringToNumber(programDetails?.basePrice),
    tdsPercentage,
    taxFee,
  );
  //  const totalAmount = (stringToNumber(programDetails?.basePrice)+ taxFee - tds).toFixed(2)
  const inputValues = [
    {
      label: "Total",
      value: programDetails?.basePrice,
    },
    {
      label: gstLabel,
      value: `INR ${taxFee.toFixed(2)}`,
    },
    {
      label: "TDS",
      value: `INR - ${tds}`,
    },
  ];
  const finalValue = {
    label: "Total Payable",
    value: toPrefill ? `${totalAmount}` : `INR ${totalAmount}`,
  };
  return { finalValue, inputValues };
};

export const getAllocatedProgramData = (
  userRegistration: userRegistration | null,
) => {
  console.log("userRegistration", userRegistration);
  if (userRegistration) {
    if (userRegistration?.program.isGroupedProgram) {
      return userRegistration?.allocatedProgram;
    } else if (
      userRegistration?.program?.noOfSession != undefined &&
      userRegistration?.program?.noOfSession != null &&
      userRegistration?.program?.noOfSession > 0
    ) {
      return userRegistration.programSession;
    } else {
      return userRegistration?.program;
    }
  } else return null;
};

export const getSuccessStatus = (
  showSuccess: boolean,
  userStatus: userRegistration | null,
  showAdditionalInfo: boolean,
) => {
  if (showSuccess && !showAdditionalInfo) {
    return true;
  } else if (
    showSuccess &&
    userStatus?.registrationStatus === PENDING &&
    userStatus.paymentDetails.length > 0 &&
    (userStatus.paymentDetails[0]?.paymentStatus === OFFLINE_PENDING ||
      userStatus.paymentDetails[0]?.paymentStatus === ONLINE_COMPLETED ||
      userStatus.paymentDetails[0]?.paymentStatus == OFFLINE_COMPLETED) &&
    !showAdditionalInfo
  ) {
    return true;
  } else if (
    showSuccess &&
    userStatus?.registrationStatus === "completed" &&
    userStatus?.travelInfo &&
    !showAdditionalInfo
  ) {
    return true;
  }
  return false;
};

export const triggerWebhook = async (response: any) => {
  console.log("Triggering webhook with response:", response);
  postCall(
    endPoints.paymentWebhook,
    {
      entity: "event",
      account_id: "acc_BFQ7uQEaa7j2z7",
      event: "payment.captured",
      contains: ["payment"],
      payload: {
        payment: {
          entity: {
            id: response?.razorpay_payment_id,
            entity: "payment",
            status: "captured",
            order_id: response?.razorpay_order_id,
          },
        },
      },
    },
    false,
  )
    .then((response) => {
      console.log("Webhook triggered successfully:", response);
      return response;
    })
    .catch((error) => {
      console.error("Error triggering webhook:", error);
      return;
    });
  return null;
};

/**
 * Validates a date against dynamic past and future ranges.
 * @param {string|Date} date - The date to validate (string or Date object)
 * @param {string} dateValidationType - Should be 'dynamic' to enable this validation
 * @param {string | null | undefined} pastDateValidation - Max past range in 'YY:MM:DD' format (e.g., '00:00:60') or null/undefined
 * @param {string | null | undefined} futureDateValidation - Max future range in 'YY:MM:DD' format (e.g., '00:00:00') or null/undefined
 * @returns {boolean} - true if valid, false otherwise
 */
export function validateDateWithDynamicRange(
  date: string | Date,
  dateValidationType: string,
  pastDateValidation?: string | null,
  futureDateValidation?: string | null,
): boolean {
  if (dateValidationType !== "dynamic") return true;
  const inputDate = typeof date === "string" ? new Date(date) : date;
  if (isNaN(inputDate.getTime())) return false;
  const now = new Date();

  function parseRange(range: string) {
    const [yy, mm, dd] = range.split(":").map(Number);
    return { years: yy || 0, months: mm || 0, days: dd || 0 };
  }

  let minDate = new Date(now);
  let maxDate = new Date(now);

  if (pastDateValidation) {
    const past = parseRange(pastDateValidation);
    minDate = new Date(
      now.getFullYear() - past.years,
      now.getMonth() - past.months,
      now.getDate() - past.days,
    );
  }

  if (futureDateValidation) {
    const future = parseRange(futureDateValidation);
    maxDate = new Date(
      now.getFullYear() + future.years,
      now.getMonth() + future.months,
      now.getDate() + future.days,
    );
  }

  console.log("minDate", minDate, "maxDate", maxDate, "inputDate", inputDate);
  return inputDate >= minDate && inputDate <= maxDate;
}

export async function validateGSTNumber(
  pincode: string,
  gstNumber: string,
): Promise<boolean> {
  // console.log('validateGSTNumber', pincode, gstNumber);
  try {
    // Fetch state and state code for the given pincode
    const response = await axios.get(
      `https://api.postalpincode.in/pincode/${pincode}`,
    );
    // console.log('response', response.data);
    const stateName = response.data?.[0]?.PostOffice?.[0]?.State;

    const gstCodeOfState = stateGstCodes.find(
      (item: any) => item?.stateName === stateName,
    );

    // Extract the state code from the GST number
    const stateCode = gstCodeOfState ? gstCodeOfState?.code : "";

    // console.log(
    //   (gstCodeOfState && gstNumber?.startsWith(stateCode)) || false,
    //   'TEST VALID GST'
    // );

    // Check if the GST number starts with the state code
    return gstCodeOfState ? gstNumber?.startsWith(stateCode) : false;
  } catch (error) {
    // console.error('Error fetching pincode details:', error);
    return false;
  }
}

// export function isRegistrationsOpen (programDetails: ProgramDetails | null): boolean {
//   if (!programDetails) return false;
//   const currentDate = new Date();
//   const startDate = new Date(programDetails?.registrationStartsAt);
//   const endDate = new Date(programDetails?.registrationEndsAt);
//   // Check if the current date is within the registration period
//   return currentDate >= startDate && currentDate <= endDate;
// }

export const getAllocatedProgamPrice = (
  userRegistration: userRegistration | null,
) => {
  if (userRegistration) {
    if (userRegistration?.program.isGroupedProgram) {
      console.log(
        "userRegistration?.allocatedProgram?.allocatedProgram",
        userRegistration?.allocatedProgram?.basePrice,
      );
      return {
        price: stringToNumber(userRegistration?.allocatedProgram?.basePrice),
        program: userRegistration?.allocatedProgram,
      };
    } else if (
      userRegistration?.program?.noOfSession != undefined &&
      userRegistration?.program?.noOfSession != null &&
      userRegistration?.program?.noOfSession > 0
    ) {
      console.log(
        "userRegistration?.allocatedProgram?.programSession",
        userRegistration?.allocatedProgram?.basePrice,
      );

      return {
        price: stringToNumber(userRegistration.programSession?.basePrice),
        program: userRegistration.programSession,
      };
    } else {
      console.log(
        "userRegistration?.allocatedProgram?.basePrice",
        userRegistration?.allocatedProgram?.basePrice,
      );
      return {
        price: stringToNumber(userRegistration?.program?.basePrice),
        program: userRegistration?.program,
      };
    }
  } else return null;
};

// Add the function to get registration status
export const getRegistrationStatus = async (
  registrationId: number,
): Promise<RegistrationStatus> => {
  try {
    const response = await getCall(
      `registration/${registrationId}/statuses`,
      undefined,
      false,
    );
    if (response?.data?.statusCode === 200) {
      return response.data.data;
    }
    throw new Error("Failed to get registration status");
  } catch (error) {
    console.error("Error getting registration status:", error);
    throw error;
  }
};

export const getPrice = (userStatus: any, formData: any, option: string) => {
  if (option != "Cash") {
    return true;
  }
  const result = getAllocatedProgamPrice(userStatus);
  const program = result?.program;
  const { finalValue, inputValues } = getInputValues(
    program,
    formData || {},
    true,
  );
  return stringToNumber(finalValue?.value) < 200000;
};
